export default "__VITE_ASSET__Co9mpTP5__"